import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ConfirmationDialogComponent } from '@common/confirmation-dialog/confirmation-dialog.component';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { commonImages } from '@images/common-images';
import { contractImages } from '@images/contract-images';
import { contractCondition, contractEmail, contractForm } from '@models/contract.model';
import { ApiService } from '@services/api/api.service';
import { ContractApiService } from '@services/api/contract.service';
import { ListingPropertiesService } from '@services/api/listing-properties.service';
import { SharedService } from '@services/api/shared.service';
import { WorkflowService } from '@services/api/workflow.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { Utils } from '@services/helpers/utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { MessageService } from '@services/util/message.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { ContractService } from '../contract.service';

@Component({
  selector: 'app-contract-form',
  templateUrl: './contract-form.component.html',
  styleUrls: ['./contract-form.component.scss'],
})
export class ContractFormComponent implements OnInit {
  @ViewChild('contractDeleteDialog') contractDeleteDialog: ConfirmationDialogComponent;
  @ViewChild('contractFormElement') formElementRef!: ElementRef;
  Utils = Utils; // 👈 expose Utils class to the template

  @Output() contractCancle = new EventEmitter<any>();
  @Output() contractRendor = new EventEmitter<boolean>();
  @Input() contractId: any;
  @Input() buyerName: any;
  @Input() validationIssue: any;
  @Input() listingId: any;
  @Input() propertyList: Observable<any> = null;
  @Input() create_contact: Observable<any> = null;

  contract: contractForm = new contractForm();
  contractEmail: contractEmail = new contractEmail();
  property_id: any;
  property_name: any;
  images = contractImages;
  common_images = commonImages;

  public userRole: string = Crypto.decrypt(this.localStorageService.GetItem('role'))?.toLowerCase();
  public userPermission = Crypto.decrypt(this.localStorageService.GetItem('_per'));

  public Editor = ClassicEditor;

  constructor(
    public lmService: LeadManagementService,
    private api: ApiService,
    private toast: ToastrService,
    private _workflowService: WorkflowService,
    private localStorageService: LocalStorageService,
    public contractService: ContractService,
    private _contractService: ContractApiService,
    private _sharedService: SharedService,
    private _listingPropertiesService: ListingPropertiesService,
    private message: MessageService,
    private remmiConfirm: RemmiConfirmService
  ) {}

  public user_permission: any = Crypto.decrypt(this.localStorageService.GetItem('_per'));
  public user_role: string = Crypto.decrypt(this.localStorageService.GetItem('role'));

  readonly foreign: any[] = [{ tag_name: 'Yes' }, { tag_name: 'No' }];
  readonly occupier_investor: any[] = [{ tag_name: 'Owner Occupier' }, { tag_name: 'Investor' }];
  readonly selectAssign: any[] = [
    { name: 'Contact', value: 'contact' },
    { name: 'Staff', value: 'staff' },
  ];

  formal_fields: { name: string; label: string }[] = [];
  requiredErrorMessages: any[] = [];
  numOfNotValidFields: number = 0;
  notDisplayRequiredMessage: boolean = true;
  contractListing: any = null;
  emailTemplates: any;

  contact_create_ele: any;
  contract_price_edit_by_user: boolean = false;

  ngOnInit(): void {
    // get properties list
    this.getProperties();

    // get all agents
    this.contractService.getAgents();

    // get all contract tags
    this.contractService.getContractTags();

    // get all short contacts
    // this.lmService.getShortContacts(true);

    if (this.lmService.contract_show_div == 'edit_contract') {
      // if validation issue is there, show error message
      if (this.validationIssue?.length > 0) {
        this.toast.error('Required fields must be filled in');
        this.validateFieldsOnRequest(
          this.validationIssue[0]?.issueField?.filter(result => result !== undefined && result !== null && typeof result !== 'string')
        );
      }
      // edit contract form
      this.editContractForm();
    } else {
      // set project listing
      this.contract.projectListing = 'listing';
    }
    // get properties list
    this.propertyList?.subscribe(rex => rex && this.getProperties);

    // listen to contact create
    this.create_contact?.subscribe(rex => {
      if (this.contact_create_ele == 'seller') {
        this.contract.seller = this.contract.seller == null ? [rex] : [...this.contract?.seller, rex];
      } else if (this.contact_create_ele == 'seller_solicitor') {
        this.contract.sellerSolicitor = this.contract.sellerSolicitor == null ? [rex] : [...this.contract?.sellerSolicitor, rex];
      } else if (this.contact_create_ele == 'buyer') {
        this.contract.buyer = this.contract.buyer == null ? [rex] : [...this.contract?.buyer, rex];
      } else if (this.contact_create_ele == 'buyer_solicitor') {
        this.contract.buyerSolicitor = this.contract.buyerSolicitor == null ? [rex] : [...this.contract?.buyerSolicitor, rex];
      }
    });
  }

  deleteContract() {
    this.remmiConfirm
      .delete({ title: 'Delete Contract?', message: 'This contract will be permanently deleted.', subject: this.property_name })
      .subscribe(isConfirmed => {
        if (!isConfirmed) {
          return;
        }
        let id = this.contractId ? this.contractId : this.insertedId;
        this._contractService.deleteContract(id).subscribe({
          next: response => {
            this.toast.success(response.message);
            this.contractRendor.emit(true);
            this.closeContract();
          },
        });
      });
  }

  getNotes(notes) {
    console.log('contract_notes >>:', notes);
    notes && this.getAllNotes();
  }

  pinned_notes: any = [];
  getAllNotes = () => {
    let id = this.contractId ? this.contractId : this.insertedId;
    this.api.get(`/user-notes?office_id=${this.api.getOfficeId()}&id=${id}`).subscribe(rex => {
      console.log('notes_list:', rex);
      this.pinned_notes = rex?.data.filter(ele => ele?.isPin == true);
    });
  };

  selected_contract: any = null;
  is_notes: boolean = false;
  is_history: boolean = false;
  editContractForm() {
    let id = this.contractId ? this.contractId : this.insertedId;
    if (id) {
      this._contractService.getContractById(id).subscribe({
        next: response => {
          this.getAllNotes();
          this.selected_contract = response?.data;
          this.contract = response?.data;
          this.contract.projectListing = response?.data?.projectListing ? response?.data?.projectListing : 'listing';
          if (this.validationIssue?.length > 0) {
            delete response?.data?.contractStatus;
            this.contract.contractStatus = this.validationIssue[0]?.tag_name;
          }
          this.contractListing = { ...response.data?.listing_detail };
          this.contract.cancelledDate = response?.data?.cancelledDate ? new Date(response?.data?.cancelledDate) : null;
          if (this.contract.cancelledDate) {
            this.is_cancelled = false;
          }
          delete this.contract['listing_detail'];
          this.contract_price_edit_by_user = response.data?.contract_price_edit_by_user === true ? true : false;
          this.property_id = response.data?.listingid;
          this.contract.dateOffer = response?.data?.dateOffer ? new Date(response?.data?.dateOffer) : null;
          this.contract.dateOfferTerms = response?.data?.dateOfferTerms ? new Date(response?.data?.dateOfferTerms) : null;
          this.contract.contractDate = response?.data?.contractDate ? new Date(response?.data?.contractDate) : null;
          this.contract.contractIssuedDate = response?.data?.contractIssuedDate ? new Date(response?.data?.contractIssuedDate) : null;
          this.contract.contractReceivedDate = response?.data?.contractReceivedDate ? new Date(response?.data?.contractReceivedDate) : null;
          this.contract.collingExpire = response?.data?.collingExpire ? new Date(response?.data?.collingExpire) : null;
          this.contract.unconditionalDate = response?.data?.unconditionalDate ? new Date(response?.data?.unconditionalDate) : '';
          this.contract.financeDate = response?.data?.financeDate ? new Date(response?.data?.financeDate) : null;
          this.contract.depositDue = response?.data?.depositDue ? new Date(response?.data?.depositDue) : null;

          this.contract.pastDue = response?.data?.pastDue ? new Date(response?.data?.pastDue) : null;
          this.contract.balanceDepositDue = response?.data?.balanceDepositDue ? new Date(response?.data?.balanceDepositDue) : null;
          this.contract.settlement = response?.data?.settlement ? new Date(response?.data?.settlement) : null;
          this.contract.condition?.forEach(x => {
            x.contractConditionDue = x?.contractConditionDue ? new Date(x?.contractConditionDue) : null;
          });
          this.properties.forEach(x => {
            x?._id === response.data?.listingid ? (this.property_name = x?.property_address) : '';
          });
          this.checkProcessRuning(id);
          this.acceptDecline(false);
        },
        error: error => {
          this.toast.error(error?.message);
        },
      });
    }
  }

  no_process_run: boolean = false;
  checkProcessRuning(id: string) {
    // Check if any process is running on the contract
    // If no process is running then enable the accept/decline button
    this._workflowService.GetAllProcessesByModule(id, 'contract', 1, 10, '', 'progress').subscribe({
      next: response => {
        this.no_process_run = !response?.data?.length ? true : false;
      },
    });
  }

  closeContract() {
    // Close the contract form by removing the contract tab
    // and emitting an event to the parent component to close the contract tab
    let tab = this.lmService.tab_levels.find(el => el.name.includes('Contract'));
    if (tab) {
      let ind = this.lmService.tab_levels.indexOf(tab);
      tab['taskTabs'] = true;
      this.contractCancle.emit({ level: tab, index: ind });
    }
  }

  properties: any[] = [];
  getProperties() {
    // Get properties from the API
    if (this.api.getOfficeId()) {
      let settled = this.contract.contractStatus === 'Settled' ? true : false;
      this._listingPropertiesService.getShortListing(false, settled, true, true).subscribe({
        next: response => {
          console.log('response1', response);
          // Clear the properties array
          this.properties = [];
          // Set the properties array to the response data
          this.properties = response?.data;
          this.contractPreFilled();
        },
      });
    }
  }

  contractPreFilled(isForm: boolean = false) {
    console.log('this.listingId', this.listingId);

    let listingId = isForm ? this.contract?.listingid : this.listingId;
    this._listingPropertiesService.contractFilled(listingId).subscribe({
      next: response => {
        console.log('response', response);
        this.contract.listingid = response?.data?._id;
        this.contract.listingAgent = response?.data?.agent;
        this.contract.managingAgent = response?.data?.agent;
        this.contract.seller = response?.data?.seller;
        this.contract.sellerSolicitor = response?.data?.sellerSolicitor;
        this.contract.buyer = response?.data?.buyer;
        this.contract.buyerSolicitor = response?.data?.buyerSolicitor;
      },
    });
  }

  selectDate(controller: string, index: number = 0) {
    // When the dateOffer field is changed, update the dateOfferTerms field to be the same value
    if (controller == 'dateOffer') {
      let date_value = this.contract.dateOffer;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.dateOffer = new Date(val);
    }
    // When the dateOfferTerms field is changed, update the dateOfferTerms field to be the same value
    else if (controller == 'dateOfferTerms') {
      let date_value = this.contract.dateOfferTerms;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.dateOfferTerms = new Date(val);
    }
    // When the contractIssuedDate field is changed, update the contractIssuedDate field to be the same value
    else if (controller == 'contractIssuedDate') {
      let date_value = this.contract.contractIssuedDate;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.contractIssuedDate = new Date(val);
    }
    // When the contractReceivedDate field is changed, update the contractReceivedDate field to be the same value
    else if (controller == 'contractReceivedDate') {
      let date_value = this.contract.contractReceivedDate;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.contractReceivedDate = new Date(val);
    }
    // When the contractDate field is changed, update the contractDate field to be the same value
    else if (controller == 'contractDate') {
      let date_value = this.contract.contractDate;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.contractDate = new Date(val);
      this.acceptDecline();
    } else if (controller == 'collingExpire') {
      let date_value = this.contract.collingExpire;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.collingExpire = new Date(val);
    }
    // When the unconditionalDate field is changed, update the unconditionalDate field to be the same value
    else if (controller == 'unconditionalDate') {
      let date_value = this.contract.unconditionalDate;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.unconditionalDate = new Date(val);
    }
    // When the settlement field is changed, update the settlement field to be the same value
    else if (controller == 'settlement') {
      let date_value = this.contract.settlement;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.settlement = new Date(val);
    } else if (controller == 'depositeDue') {
      let date_value = this.contract.depositDue;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.depositDue = new Date(val);
    }
    // When the pastDue field is changed, update the pastDue field to be the same value
    else if (controller == 'pastDue') {
      let date_value = this.contract.pastDue;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.pastDue = new Date(val);
    } else if (controller == 'balanceDepositDue') {
      let date_value = this.contract.balanceDepositDue;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.balanceDepositDue = new Date(val);
    }
    // When the financeDate field is changed, update the financeDate field to be the same value
    else if (controller == 'financeDate') {
      let date_value = this.contract.financeDate;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.financeDate = new Date(val);
    } else if (controller == 'condition') {
      let date_value = this.contract.condition[index].contractConditionDue;
      let val = Utils.getDateStringFormat(date_value);
      this.contract.condition[index].contractConditionDue = new Date(val);
    }
  }

  calculateAmount() {
    this.contract.totalDeposit = this.contract.initialDeposit + this.contract.balanceDeposit;
  }

  valueCopyAndCalculate() {
    this.contract.contractPrice = this.contract.offerPrice;
    this.contract.initialDeposit = this.contract.initialDepositAmount || 0;
    this.contract.balanceDeposit = this.contract.balanceDepositAmount || 0;
    this.contract.contractPrice = this.contract.offerPrice || 0;
    this.contract.totalDeposit = this.contract.initialDeposit + this.contract.balanceDeposit;
  }

  updatePrice(value, param: string) {
    console.log('value >>:', value, 'Param >>:', param);
    if (param == 'contract_price') {
      this.contract_price_edit_by_user = true;
      this.contract.contractPrice = value;
    } else if (param == 'offer_price') {
      this.contract.offerPrice = value;
      this.valueCopyAndCalculate();
    } else if (param == 'initial_deposit_amount') {
      this.contract.initialDepositAmount = value;
      this.valueCopyAndCalculate();
    } else if (param == 'balance_deposit_amount') {
      this.contract.balanceDepositAmount = value;
      this.valueCopyAndCalculate();
    } else if (param == 'balance_deposit_amount') {
      this.contract.balanceDepositAmount = value;
      this.valueCopyAndCalculate();
    } else if (param == 'initial_deposit') {
      this.contract.initialDeposit = value;
      this.contract.totalDeposit = this.contract.initialDeposit + this.contract.balanceDeposit;
    } else if (param == 'balance_deposit') {
      this.contract.balanceDeposit = value;
      this.contract.totalDeposit = this.contract.initialDeposit + this.contract.balanceDeposit;
    } else if (param == 'total_deposit') {
      this.contract.totalDeposit = value;
    }
  }

  libraryDataEmitter: [] = [];
  GetLibraryData(event: any) {
    this.libraryDataEmitter = event;
  }

  insertedId: any;
  singleClick: boolean = false;
  saveContract(saveMethod: string, form: any) {
    if (!this.insertedId) {
      this.contract['office_id'] = this.api.getOfficeId();
      this.contract['contract_price_edit_by_user'] = this.contract_price_edit_by_user;
      this._contractService.createContract(this.contract).subscribe({
        next: response => {
          this.singleClick = false;
          this.insertedId = response?.insertedId;
          this.lmService.propertyId = null;
          this.toast.success('Contract added successfully');
          this.editContractForm();
          this.message.getModuleHistory(true);
          this.contractRendor.emit(true);
          if (saveMethod !== 'onlySave') {
            this.closeContract();
            form.reset();
          }
          this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
        },
        error: error => {
          this.singleClick = false;
          this.toast.error(error?.error?.message ? error?.error?.message : error?.message);
          let { fields, all_fields } = error?.error;
          if (fields?.length > 0) {
            this.formal_fields = fields = fields?.map(error_field => {
              let isExistsField = all_fields?.find(field => field?.name?.trim() === error_field);
              if (
                (isExistsField &&
                  this.contract.hasOwnProperty(error_field) &&
                  (this.contract[error_field] === '' || this.contract[error_field] === null)) ||
                !this.contract[error_field]?.length ||
                this.contract[error_field]?.length == 0
              ) {
                error_field = { name: error_field, label: isExistsField?.label || '' };
              }
            });
          } else {
            this.toast.error('Existing Accept Offer pending. To accept this offer the other offer must be declined first');
          }
        },
      });
    } else {
      this.contract['office_id'] = this.api.getOfficeId();
      this.contract['contract_price_edit_by_user'] = this.contract_price_edit_by_user;
      this._contractService.updateContract(this.insertedId, this.contract).subscribe({
        next: _ => {
          this.singleClick = false;
          this.lmService.propertyId = null;
          this.toast.success('Contract update successfully');
          this.editContractForm();
          this.contractRendor.emit(true);
          this.message.getModuleHistory(true);
          if (saveMethod !== 'onlySave') {
            this.closeContract();
            form.reset();
          }
          this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
        },
        error: error => {
          this.singleClick = false;
          this.toast.error(error?.error?.message ? error?.error?.message : error?.message);
          let { fields, all_fields } = error?.error;
          if (fields?.length > 0) {
            this.formal_fields = fields = fields?.map(error_field => {
              let isExistsField = all_fields?.find(field => field.name?.trim() === error_field);
              if (
                (isExistsField &&
                  this.contract.hasOwnProperty(error_field) &&
                  (this.contract[error_field] === '' || this.contract[error_field] === null)) ||
                !this.contract[error_field]?.length ||
                this.contract[error_field]?.length == 0
              ) {
                error_field = { name: error_field, label: isExistsField?.label || '' };
              }
              return error_field;
            });
            this.toast.error('Required fields must be filled in');
            this.validateFieldsOnRequest(fields?.filter(result => result !== undefined && result !== null && typeof result !== 'string'));
          } else {
            this.toast.error('Existing Accept Offer pending. To accept this offer the other offer must be declined first');
          }
        },
      });
    }
  }

  updateContract(saveMethod: string, form: any) {
    // Update the contract

    this.contract['office_id'] = this.api.getOfficeId();
    this.contract['contract_price_edit_by_user'] = this.contract_price_edit_by_user;
    if (this.contract.contractPrice != null) {
      this.contract.contractPrice = parseFloat(Number(this.contract.contractPrice).toFixed(2));
    }
    delete this.contract['_id'];
    this._contractService.updateContract(this.contractId, this.contract).subscribe({
      next: _ => {
        this.singleClick = false;
        this.lmService.propertyId = null;
        this.toast.success('Contract update successfully');
        this.editContractForm();
        this.contractRendor.emit(true);
        this.message.getModuleHistory(true);
        if (saveMethod !== 'onlySave') {
          this.closeContract();
          form.reset();
        }
        this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
        if (this.contract.contractStatus == 'Settled' && this.contract.offer_status == 'Accepted') {
          this.contract.contractPrice = this.contract.offerPrice;
        }
      },
      error: error => {
        this.singleClick = false;
        this.toast.error(error?.error?.message ? error?.error?.message : error?.message);
        let { fields, all_fields } = error?.error;
        if (fields?.length > 0) {
          this.formal_fields = fields = fields?.map(error_field => {
            let isExistsField = all_fields?.find(field => field.name?.trim() === error_field);
            if (
              (isExistsField &&
                this.contract.hasOwnProperty(error_field) &&
                (this.contract[error_field] === '' || this.contract[error_field] === null)) ||
              !this.contract[error_field]?.length ||
              this.contract[error_field]?.length == 0
            ) {
              error_field = { name: error_field, label: isExistsField?.label || '' };
            }
            return error_field;
          });
          this.toast.error('Required fields must be filled in');
          this.validateFieldsOnRequest(fields?.filter(result => result !== undefined && result !== null && typeof result !== 'string'));
        } else {
          this.toast.error('Existing Accept Offer pending. To accept this offer the other offer must be declined first');
        }
      },
    });
  }

  editRecord(record) {
    this.openRightModal(record, 'edit_contact');
  }

  openRightModal(contact: any, addOrEdit: string, isPortal: boolean = false) {
    // if (contact == null) {
    //   let contact_id = contact?.contact?._id ? contact?.contact?._id : contact?._id;
    //   this.lmService.addTabInLevels(`Contact`, contact_id, contact);
    // }
    if (addOrEdit === 'edit_contact') {
      // edit contact
      // set flag to stop reloading add contact component
      this.lmService.reload_add_contacts = false;
      // get contact id
      let contact_id = contact?.contact?._id ? contact?.contact?._id : contact?._id;
      // get contact name
      let name = '';
      if (contact?.contact) {
        name =
          contact?.contact?.full_name !== ' '
            ? contact?.contact?.full_name
            : contact?.contact?.company_name
              ? contact?.contact?.company_name
              : contact?.name;
      } else {
        name = contact?.full_name ? contact?.full_name : contact?.company_name ? contact?.company_name : contact?.name;
      }
      // set flag to show edit contact component
      this.lmService.isEdit_show_div = addOrEdit;
      // add contact to levels
      this.lmService.addTabInLevels(`Contact-${name}`, contact_id, contact, {}, 'contact');
      // show right bar
      this.lmService.contact_showRightBar = true;
      // set contact id
      this.lmService.cont_id = contact_id;
      // after 500ms set flag to reload add contact component
      setTimeout(() => {
        this.lmService.reload_add_contacts = true;
      }, 500);
    }
    // add contact
    else if (addOrEdit === 'add_contact') {
      // set flag to show add contact component
      this.lmService.contact_show_div = addOrEdit;
      // add contact to levels
      this.lmService.addTabInLevels('Contact', 'createnew', null);
      // show right bar
      this.lmService.contact_showRightBar = true;
    }
    // edit listing property
    else if (addOrEdit === 'edit_listing_property') {
      // set flag to show edit listing component
      this.lmService.listing_show_div = addOrEdit;
      // add listing to levels
      this.lmService.addTabInLevels('Listing' + ' - ' + contact?.property_address, contact?._id, contact);
      // show right bar
      this.lmService.contact_showRightBar = true;
      // set flag to stop creating new listing
      this.lmService.is_new_listing = false;
      // set flag to indicate if user is in portal or not
      this.lmService.isPortal = isPortal;
    }
  }

  changeDue() {
    this.acceptDecline();
  }

  is_cancelled: boolean = false;
  acceptDecline(value_null: boolean = false) {
    if (value_null == true) {
      this.contract.offer_status === 'Cancelled' ? (this.is_cancelled = true) : (this.is_cancelled = false);
      this.contract.cancelledDate = null;
    }
    if (value_null == false) {
      this.contract.offer_status === 'Cancelled' ? (this.is_cancelled = true) : (this.is_cancelled = false);
      // this.contract.cancelledDate = null;
    }

    if (this.contract.offer_status === 'Accepted' || this.contract.offer_status === 'Presented') {
      let offer_date = this.contract.dateOffer;
      let val1 = Utils.getDateStringFormat(offer_date);
      this.contract.dateOfferTerms = new Date(val1);

      let contract_date = this.contract.contractDate;
      let val = Utils.getDateStringFormat(contract_date);
      let baseDate = new Date(val);
      this.contract.contractDate = baseDate;

      let settlement_date = new Date(baseDate.getTime());
      settlement_date.setDate(settlement_date.getDate() + Number(this.contract.settlementTerm));
      this.contract.settlement = settlement_date;

      let initial_deposit = new Date(baseDate.getTime());
      initial_deposit.setDate(initial_deposit.getDate() + Number(this.contract.initialDepositAmountPayable));
      this.contract.depositDue = initial_deposit;

      let balance_deposit = new Date(baseDate.getTime());
      balance_deposit.setDate(balance_deposit.getDate() + Number(this.contract.balanceDepositAmountPayable));
      this.contract.balanceDepositDue = balance_deposit;

      let building_pest = new Date(baseDate.getTime());
      building_pest.setDate(building_pest.getDate() + Number(this.contract.buildingPestTerm));
      this.contract.pastDue = building_pest;

      let finance_date = new Date(baseDate.getTime());
      finance_date.setDate(finance_date.getDate() + Number(this.contract.financeTerm));
      this.contract.financeDate = finance_date;

      let collingExpireDate = new Date(baseDate.getTime());
      collingExpireDate.setDate(collingExpireDate.getDate() + 4);
      this.contract.collingExpire = collingExpireDate;
    }
  }

  openModal() {
    this.contractDeleteDialog.show();
    this.getEmailTemplate();
  }

  AddNotesTrigger: Subject<Boolean> = new Subject<Boolean>();
  defaultFormSetting = {
    contract: false,
    agent: false,
    offerTerms: false,
    additionalInformation: false,
    contractTerms: false,
    notesDocument: false,
  };
  CollapseBoxActionTriggered(actionName: string) {
    // Action name is required
    if (!actionName) {
      return;
    }

    // if action name starts with 'opened-' or 'closed-' then toggle the respective form setting
    else if (actionName?.startsWith('opened-') || actionName?.startsWith('closed-')) {
      // Split the action name into two parts
      let action = actionName.split('-');

      // If action name starts with 'opened-Contracts Details', then toggle the contract form setting
      if (action[1] === 'Contracts Details') {
        this.defaultFormSetting = { ...this.defaultFormSetting, contract: action[0] === 'opened' ? false : true };
      }
      // If action name starts with 'opened-Agent', then toggle the agent form setting
      else if (action[1] === 'Agent') {
        this.defaultFormSetting = { ...this.defaultFormSetting, agent: action[0] === 'opened' ? false : true };
      }
      // If action name starts with 'opened-Additional Information', then toggle the additional information form setting
      else if (action[1] === 'Additional Information') {
        this.defaultFormSetting = {
          ...this.defaultFormSetting,
          additionalInformation: action[0] === 'opened' ? false : true,
        };
      }
      // If action name starts with 'opened-Contract Terms', then toggle the contract terms form setting
      else if (action[1] === 'Contract Terms') {
        this.defaultFormSetting = { ...this.defaultFormSetting, contractTerms: action[0] === 'opened' ? false : true };
      }
      // If action name starts with 'opened-Offer Terms', then toggle the offer terms form setting
      else if (action[1] === 'Offer Terms') {
        this.defaultFormSetting = { ...this.defaultFormSetting, offerTerms: action[0] === 'opened' ? false : true };
      }
      // If action name starts with 'opened-Notes / Document', then toggle the notes document form setting
      else if (action[1] === 'Notes / Document') {
        this.defaultFormSetting = { ...this.defaultFormSetting, notesDocument: action[0] === 'opened' ? false : true };
      }
    }
  }

  addCondition() {
    const detail = new contractCondition();
    this.contract.condition.push(detail);
  }
  removeCondition(i) {
    this.contract.condition.splice(i, 1);
  }
  email_cc: any[] = [];
  addEmailCC() {
    this.email_cc?.push({ type: null, email_cc: null });
  }
  removeEmailCC(i) {
    this.email_cc?.splice(i, 1);
  }

  selectedTemplate: any;
  firstTemplate: any[] = [];
  getEmailTemplate() {
    // Get all email templates
    this._sharedService.getEmailTemplate().subscribe({
      next: response => {
        this.emailTemplates = response.data;
        // Filter only contract type email templates
        this.emailTemplates = this.emailTemplates.filter(x => x.type == 'contract');
        // Set the selected seller emails
        this.contractEmail.to = this.contract.seller || [];
        let agent = this.contractService.office_staff?.find(staff => staff?.full_name == this.contract.listingAgent);
        this.email_cc = [{ type: 'staff', email_cc: agent?.['email'] }];
        // Set the first email template as the default email template
        this.contractEmail.emailTemplate = this.emailTemplates[0]?._id;
        // this.contractEmail.from = 'ypm<noreply@ypm.com.au>';
        this.contractEmail.subject = this.emailTemplates[0]?.subject;
        this.contractEmail.body = this.emailTemplates[0]?.body;
      },
    });

    // Set the first email template after 3 seconds
    // This is to ensure that the email template is set after the form is fully loaded
    setTimeout(() => {
      this.firstTemplate.push(this.emailTemplates[0]);
    }, 3000);
  }
  templateContract: any;
  getTemplateBody(event: any) {
    /**
     * Sets the email template for the contract offer email
     * @param event the selected email template
     */
    this.contractEmail.emailTemplate = event?._id;
    /**
     * Sets the from email address for the contract offer email
     */
    this.contractEmail.from = 'remmi<noreply@remmi.com.au>';
    /**
     * Sets the email subject for the contract offer email
     */
    this.contractEmail.subject = event?.subject;
    /**
     * Sets the email body for the contract offer email
     */
    this.contractEmail.body = event?.body;
  }
  sendEmail() {
    /**
     * Sends an email to present the contract offer with the specified details.
     */
    let combinedEmails: string[] = [];

    // Combine all CC emails from email_cc array
    this.email_cc.forEach(item => {
      combinedEmails = combinedEmails.concat(item.email_cc);
    });

    // Prepare and send the API request to present the contract offer

    let payload = {
      to: this.contractEmail.to,
      cc: combinedEmails,
      subject: this.contractEmail.subject || '',
      body: this.contractEmail.body || '',
      contractid: this.contractId || this.insertedId,
    };

    this._contractService.contractPresentOffer(payload).subscribe({
      next: _ => {
        // On success, show a success message and update contract status
        this.toast.success('Mail sent successfully');
        this.contractRendor.emit(true);
        this.contract.offer_status = 'Presented';
      },
      error: () => {
        // On error, notify the user to save the contract first
        this.toast.error('Please save the contract before presenting an offer');
      },
    });
  }

  validateFieldsOnRequest(fields: any[] = []) {
    /**
     * Validates the specified fields in the UserForm and collects error messages if validation fails
     * @param fields An array of objects containing the field name, label, and any additional information
     *   required for validation.
     */
    if (fields?.length > 0) {
      // Reset the error messages and count of invalid fields
      this.numOfNotValidFields = this.requiredErrorMessages.length = 0;

      // Iterate through the fields to check for validation errors
      for (let field of fields) {
        // Check if the field name exists in the contract object and if the value is null or empty
        if (
          Object.keys(this.contract).some(key => field?.name?.trim() == key) &&
          (this.contract[field.name?.trim()] == null || this.contract[field.name?.trim()] == '')
        ) {
          // If the field label exists, create an error object with the field name and label message
          if (field?.label) {
            let fieldReqObj = {
              field: field.name?.trim(),
              message: `${field?.label}`,
            };
            this.requiredErrorMessages.push(fieldReqObj);
            this.numOfNotValidFields++; // Increment the invalid fields count
          }
        }
      }
    }
  }

  ActivateTabIndexByError(message: string) {
    /**
     * Activates the tab index and scrolls to the form element associated with the given error message.
     * @param message The error message containing the form control name, id, or name attribute to locate.
     */
    let space_separated: string[] = message?.trim()?.split(' ');
    if (space_separated?.[0]?.trim()?.length > 0) {
      // Attempt to find the form element using formControlName, name, or id attribute
      const element =
        this.formElementRef.nativeElement.querySelector(`[formControlName="${space_separated?.[0]?.trim()}"]`) ||
        this.formElementRef.nativeElement.querySelector(`[name="${space_separated?.[0]?.trim()}"]`) ||
        this.formElementRef.nativeElement.querySelector(`[id="${space_separated?.[0]?.trim()}"]`);

      if (element) {
        // Scroll the element into view smoothly if found
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  isFormValueValid(key: string): boolean {
    /**
     * Checks if the given form value is valid
     * @param key The name of the form value to check
     * @returns True if the form value is valid, false otherwise
     */
    // Check if the given form value is present in the required error messages
    // If it is, that means the form value is invalid
    if (this.requiredErrorMessages.find((error): any => error.field === key)) {
      return true;
    }
    // If the form value is not present in the required error messages, it is valid
    return false;
  }

  GetListingWorkflowProcesses() {
    /**
     * @description: This function is used to open the workflow process tab on click of the workflow icon in the contract form.
     * It sets the recordId of the contract and makes an API call to get all the processes associated with the contract.
     * The response is then processed and the necessary variables are updated.
     */
    this._workflowService.isWorkflowProcessTabOpened = true;
    this._workflowService.ActiveProcessList = [];
    this._workflowService.processRecordId = this.contract?.['_id'];
    this._workflowService.active_module_name = 'contract';
    this._workflowService
      .GetAllProcessesByModule(
        this.contract?.['_id'],
        this._workflowService.module_array?.find(res => res.name?.toLowerCase() === 'Contract'?.toLowerCase())
      )
      .subscribe({
        next: response => {
          try {
            const { status, data, meta } = response;
            if (status) {
              // If there are no processes associated with the contract, then set the variable no_process_run to true
              // and set the module_isStop to true.
              !data?.length
                ? ((this.no_process_run = true), (this._workflowService.module_isStop = true))
                : ((this.no_process_run = false), (this._workflowService.module_isStop = false));
              // Process the response and update the ActiveProcessList.
              this._workflowService.ActiveProcessList = data?.map(
                result =>
                  (result = {
                    ...result,
                    module: Utils.capitalizePhrase(result?.module?.split('_')?.join(' ')?.trim() || ''),
                  })
              );
              // Update the centralizedProcessPagination.
              this._workflowService.centralizedProcessPagination = {
                ...this._workflowService.centralizedProcessPagination,
                per_page: 10,
                total_pages: Math.ceil(meta?.pagination?.total / 10),
                total: meta?.pagination?.total,
                numberOfRecords: this._workflowService.ActiveProcessList?.length > 10 ? 10 : this._workflowService.ActiveProcessList?.length,
              };
            } else {
              // If the status is false, then set the ActiveProcessList to an empty array.
              this._workflowService.ActiveProcessList = [];
            }
          } catch (error) {
            // If there is an error, then set the ActiveProcessList to an empty array.
            this._workflowService.ActiveProcessList = [];
          }
        },
      });
  }

  onUpdateMSelect = (eve: any[], type: string, index = null) => {
    let ids = eve?.length > 0 ? eve.map(ele => ele?._id) : [];
    if (type === 'to') {
      this.contractEmail.to = ids;
    } else if (index !== null) {
      let cc_id = [];
      eve.forEach(ele => {
        cc_id.push(ele._id);
      });
      this.email_cc[index].email_cc = cc_id;
    } else {
      this.contract[type] = ids;
    }
  };
}
